import CommissionStats, {
  CommissionStatsPeriod,
} from "@/interfaces/CommissionStats";
import api from "@/services/api";

export const commissionStatsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMyCommissionStats: build.query<CommissionStats, CommissionStatsPeriod>({
      query: (period) => ({
        url: "/commissions/me/stats",
        params: { period },
      }),
      providesTags: [{ type: "CommissionStats", id: "ME" }],
    }),
  }),
  overrideExisting: true,
});

export const { useGetMyCommissionStatsQuery } = commissionStatsApi;
